const version = {
    noVersion : "1.06.2",
    dtVersion : "02/11/2022",
    hrVersion : "11:06"
}

export default version;


// WEBPACK FOOTER //
// ./src/donnees/version.js